export enum RetailCrmNationalIdDocumentType {
  DRIVER_LICENSE = 'Driver License',
  DRIVER_LICENSE_ID = 'Driver License Id',
  ID_CARD = 'ID Card',
  IDENTIFICATION_NUMBER = 'Identification Number',
  PASSPORT = 'Passport',
  PASSPORT_ID = 'Passport ID',
  PERSON_ID_CARD = 'Person ID Card',
  SOCIAL_SECURITY_NUMBER = 'Social Security Number',
  SOUTH_AFRICA_NATIONAL_ID = 'South Africa National ID',
}

/**
 * Write-path only: "" clears the picklist. Retail CRM merges on write and treats an absent
 * field as unchanged, so an omitted value would silently keep the stored document type.
 * Verified against dev: the field disappears from the GET after sending "".
 */
export type RetailCrmNationalIdDocumentTypeForWrite = RetailCrmNationalIdDocumentType | '';
